import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Mail, Phone } from 'lucide-react';

const ContactHeroSection: React.FC = () => {
  const contactInfo = [
    {
      icon: MapPin,
      text: 'New York, USA',
    },
    {
      icon: Mail,
      text: 'infotherealmasterji@gmail.com',
    },
    {
      icon: Phone,
      text: '+1-9293448376',
    },
  ];

  return (
    <section className="relative bg-white overflow-hidden" style={{ minHeight: '342px', paddingTop: '64px' }}>
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8" style={{ paddingLeft: 'clamp(16px, 8.89vw, 128px)', paddingRight: 'clamp(16px, 8.89vw, 128px)' }}>
        {/* Main Heading */}
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="font-opensans text-[36px] sm:text-[42px] lg:text-[52px] leading-[48px] sm:leading-[60px] lg:leading-[74px] text-brand-blue font-bold text-center mb-8"
          style={{ fontVariationSettings: "'wdth' 100" }}
        >
          Drop Us a Line
        </motion.h1>

        {/* Contact Info Items */}
        <div className="flex flex-col sm:flex-row flex-wrap justify-center items-center gap-6 sm:gap-8 lg:gap-12">
          {contactInfo.map((info, index) => {
            const Icon = info.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }}
                className="flex items-center gap-3"
              >
                <div className="w-7 h-7 flex items-center justify-center text-text-primary">
                  <Icon className="w-7 h-7" />
                </div>
                <p className="font-manrope text-[18px] leading-[28px] text-text-secondary">
                  {info.text}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ContactHeroSection;
